<template>
    <section class="otstup">
      <div class="container_test_grid_our ">
        <div class="container_test_grid_our_in Black_2_block">
          <div class="container_test_grid_our_in_right ">
            <div class="item_test_viruch otstup_viruch_our ">
              <p align="left" class="text-white text_our_block  font_text_ariblk">Выручка общая, <span class="text_our_block_ed_izmer font_text_Arial_regular">млн ₽</span></p>
            </div>
            <div class="item_test_viruch otstup_our_block">
              <p align="left" class="name_year text-white font_text_Arial_BoldMT"><span class="red_text text_our_block_fact font_text_Arial_BoldMT">{{ (data_sum_fact/1000000).toFixed(1) }}</span> из <span class="text_our_block_target font_text_Arial_BoldMT">{{ (data_sum/1000000).toFixed(1) }}</span></p>  
            </div>
          </div>
          <div class="container_test_grid_our_in_left ">
            <p class="red_text text_our_block_percent  font_text_Arial_BoldMT">{{ (((data_sum_fact/data_sum)*100)).toFixed(0) }}%</p>
          </div>
          <!-- <div class="container_test_grid_our_in_left ">
            <p class="red_text text_our_block_percent  font_text_Arial_BoldMT">8%</p>
          </div> -->
        </div>
      </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        data_sum: {
            type: String,
        },
        data_sum_fact: {
            type: String,
        }
    })
</script>

<style scoped>
@media screen and (max-width: 1400px) {
	/* html{ 
		font-size: 8px;
	} */
  .container_test_grid_our_in_right {
	display: grid;
	align-items: center;
	justify-content: start;
	margin-left: 20px;
	/* grid-template-rows: 1fr 3fr; */
  }

	.text_our_block {
    font-size: 12px;
  }

  .name_year {
	font-size: 7px;
  }

  .text_our_block_fact {
	  font-size: 20px;
  }

  .text_our_block_target {
	  font-size: 11px;
  }

  .text_our_block_ed_izmer{
	font-size: 10px;
  color: #A6A6A7;

  }

  .text_our_block_percent {
	  font-size: 24px;
  }

  .container_test_grid_our {
    margin-top: 20px;
    grid-template-columns: 3fr 3fr 1fr;
    
  }

  .container_test_grid_our_in {
    display: grid;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;

  }

  .otstup_viruch_our {
    margin-bottom: 15px;
  }

  .container_test_grid_our_in_left {
    display: grid;
    align-items: center;
    justify-content: center;
    /* grid-template-columns: 1fr; */
    /* margin-left: 50px; */
    /* margin-right: 20px; */
  }

  
}

</style>